import initialState from '../../store/initialState';

const reInitState = store => async () => {
    store.setState(initialState);
};

export default reInitState;
